import { render, staticRenderFns } from "./CatalogCreate.vue?vue&type=template&id=87939fc0&scoped=true"
import script from "./CatalogCreate.vue?vue&type=script&lang=js"
export * from "./CatalogCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87939fc0",
  null
  
)

export default component.exports